<template>
  <v-container grid-list-md fluid align-baseline pa-0>
  <v-layout row wrap>
    <v-flex xs12>
        <v-dialog
            v-model="dialogViewChat"
            fullscreen
            pa-0
            v-show="dialogViewChat"
            >
                   <v-card
                        class="mb-5"
                        color="white lighten-1"
                        ripple
                        >
                        <v-toolbar dark color="primary">
                            <v-toolbar-side-icon @click="closeDialogViewChat">
                            <v-icon>close</v-icon>
                                                          
                            </v-toolbar-side-icon>
                            <v-toolbar-title>View {{this.memberProfileView.firstname}} {{memberProfileView.lastname}}</v-toolbar-title>
                            <v-spacer></v-spacer>

                        </v-toolbar>                        

                        <v-snackbar
                            v-model="snackbar"
                        >
                            {{snackbarText}}
                            <v-btn
                                color="pink"
                                flat
                                @click="closeSnackBar"
                            >
                                Close
                            </v-btn>                            
                        </v-snackbar>



                        <v-card-title>
                            <v-layout column>
                                <v-flex>
                                    <v-layout row>
                                        <v-flex xs2>
                                            <template v-if="memberProfileView.profilepic && memberProfileView.profilepic.fileurl">
                                                <v-avatar
                                                size="35" 
                                                color="grey lighten-2"                                            
                                                ><img v-bind:src="memberProfileView.profilepic.fileurl"></v-avatar>                                          
                                            </template>
                                            <template v-else>
                                                <v-icon large>person</v-icon>
                                            </template>  
                                        </v-flex>
                                        <v-flex xs-10 v-if="memberProfileView">
                                            <div class="headline pt-1">{{memberProfileView.firstname}} {{memberProfileView.lastname}}</div>
                                            <div v-if="memberProfileView.lineid" class="caption primary--text pt-0">{{memberProfileView.lineid.split('_')[3]}} {{memberProfileView.lineid.split('_')[2]}}</div>
                                        </v-flex>
                                    </v-layout>
                                </v-flex>
                            </v-layout>
  
                            

                        </v-card-title>                        
                        <v-card-text>            
                        <v-flex xs12>
                        <v-list>
                            <v-list-tile>
                                <v-layout row>
                                <v-flex xs3 class="profilekey caption font-weight-bold">
                                    Email:
                                </v-flex>
                                <v-flex class="profilevalue caption" xs9 v-if="memberProfileView.email">
                                    {{memberProfileView.email}}
                                </v-flex>  
                                                       
                                </v-layout>
                            </v-list-tile>
                            <v-divider inset></v-divider>      
                            <template  v-if="memberProfileView.emailalts && memberProfileView.emailalts.length>0">
                            <v-list-tile v-for="emailalt in memberProfileView.emailalts" v-bind:key="emailalt">
                                <v-layout row>
                                <v-flex xs3 class="profilekey caption font-weight-bold">
                                    Alt Email:
                                </v-flex>
                                <v-flex class="profilevalue caption" xs9 v-if="emailalt">
                                    {{emailalt}}
                                </v-flex>  
                                                        
                                </v-layout>
                            </v-list-tile>
                            <v-divider inset></v-divider>
                            </template>                            
                            <v-list-tile>
                                <v-layout row>
                                <v-flex xs3 class="profilekey caption font-weight-bold">
                                    Phone:
                                </v-flex>
                                <v-flex class="profilevalue caption" xs9 v-if="memberProfileView.phone">
                                    {{memberProfileView.phone}}
                                </v-flex>                                
                                </v-layout>
                            </v-list-tile>    
                            <v-divider inset></v-divider>                              
                        </v-list>
                        </v-flex>

      <v-flex xs12 pt-3 v-if="memberProfileView.linkedin && memberProfileView.linkedin.headline">

        <template v-if="memberProfileView.linkedin && memberProfileView.linkedin.headline">
        <v-expansion-panel>
            <v-expansion-panel-content
            key="linkedin"
            >
            <div slot="header">
                                <v-layout row>
                                    <v-flex xs2>
                        <v-avatar
                            size="35" 
                            color="grey lighten-2"                                            
                            ><img v-bind:src="memberProfileView.linkedin.pictureUrl"></v-avatar>
                                    </v-flex>
                                    <v-flex xs10 class="font-weight-bold">
                            {{memberProfileView.linkedin.headline}}
                                    </v-flex>
                                </v-layout>
                                <v-layout row>
                                    <v-flex xs12 class="caption primary--text lighten-2">
                                    {{memberProfileView.linkedin.industry}}
                                    </v-flex>
                                </v-layout>                                

            </div>
                <v-card  v-if="memberProfileView.linkedin && memberProfileView.linkedin.headline">
                    <v-card-title>
                        <v-layout column>
                            <v-flex class="caption grey--text">
                                Summary: {{memberProfileView.linkedin.summary}}
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text pa-0 class="caption">


                        <template>
                        <v-expansion-panel pa-0>
                            <v-expansion-panel-content
                            key="innerExpanse"
                            >
                            <div slot="header">
                                <v-layout column>
                                    <v-flex xs12 class="text-xs-center body font-weight-bold primary--text ">
                                        POSITION HISTORY
                                    </v-flex>
                                </v-layout>          
                                
                            </div>
                            <v-card flat>
                                <v-card-text>
                                    <v-layout column>
                                        <template v-for="pos in memberProfileView.linkedin.positions.values" >
                                        <v-flex :key="pos.id">
                                            <v-layout pt-2 row>
                                                <v-flex ml-3 class="flexlabel" xs3>
                                                    {{pos.title}}
                                                </v-flex>
                                                <v-flex class="flexvalue" ml-2 xs9>
                                                    {{pos.summary}}
                                                </v-flex>                      
                                            </v-layout>
                                        </v-flex>
                                        <v-divider :key="'v-divider-' + pos.id"></v-divider>
                                        </template>
                                    </v-layout>            

                                </v-card-text>
                            </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                        </template>


                    </v-card-text>
                </v-card>

            </v-expansion-panel-content>
        </v-expansion-panel>
        </template>


      </v-flex>

            <template v-if="memberProfileView.userid && memberProfileView.userid!==member.userid">
                    <div class="subheading font-weight-medium pa-3">Send a Private Message:</div>
                    <v-card flat>
                        <v-card-text>
                            <v-layout>
                            <v-flex xs12>
                            <v-textarea
                                v-model="messagetext"
                                label="Message"
                                placeholder="Type message here."
                                auto-grow
                                outline
                                height=20
                                append-outer-icon="send"
                                :append-outer-icon-cb = "addMemberMessage"
                            ></v-textarea>

                            <v-card-actions>
                                
                                <div class='caption'></div>
                            </v-card-actions>   
                            </v-flex>       
                            </v-layout>
                        </v-card-text>
 
                    </v-card>
            </template> 
            <template v-else-if="memberProfileView.userid===member.userid">                        
                    <div class="subheading font-weight-medium pa-3"><v-icon>error</v-icon>Send a Private Message (Disabled - Can't send message to yourself):</div>
                    <v-card flat>
                        <v-card-text>
                            <v-layout>
                            <v-flex x12>
                            <v-textarea
                                v-model="messagetext"
                                label="Message"
                                placeholder="(Disabled)"
                                auto-grow
                                outline
                                disabled
                                error
                                height=20
                                append-outer-icon="send"
                                :append-outer-icon-cb = "addMemberMessage"
                            ></v-textarea>
                            </v-flex>
   
                            </v-layout>
                        </v-card-text>
 
                    </v-card>
            </template>               
            <template v-else>                        
                    <div class="subheading font-weight-medium pa-3"><v-icon>error</v-icon>Send a Private Message (Disabled - Member Not Yet Registered):</div>
                    <v-card flat>
                        <v-card-text>
                            <v-layout>
                            <v-flex x12>
                            <v-textarea
                                v-model="messagetext"
                                label="Message"
                                placeholder="(Disabled)"
                                auto-grow
                                outline
                                disabled
                                error
                                height=20
                                append-outer-icon="send"
                                :append-outer-icon-cb = "addMemberMessage"
                            ></v-textarea>
                            </v-flex>
   
                            </v-layout>
                        </v-card-text>
 
                    </v-card>
            </template>


            <template v-if="memberProfileView.userid">
                    <div class="subheading font-weight-medium pa-3">Messages:</div>

                    <v-card>
                        <v-card-text v-if="memberProfileViewMessagesDoc">
                            <template v-for="(m, index) in memberProfileViewMessagesDoc.messages" class="postComments">
                                    <v-layout v-bind:key="`vlayout--${index}`" row wrap>
                                    <v-flex v-if="m.authorid === member.userid" v-bind:key="`vflex-me-padding--${index}`" xs2 pa-3>
                                    </v-flex>
                                    <v-flex v-bind:key="`vflex--${index}`" xs10 pa-3>
                                        <div v-if="m.authorid !== member.userid" v-bind:key="`msgcard--${index}`" class="chat-card-me">                                        
                                            <v-flex xs12>
                                                                                 
                                            <div v-bind:key="`msgcontent--${index}`" class="caption pa-2 lighten-2">{{m.content}}<br/><br/></div>
                                            </v-flex>
                                        </div>

                                        <div v-else v-bind:key="`msgcard--${index}`" class="chat-card">                                        
                                            <v-flex xs12>
                                            <div v-bind:key="`msgcontent--${index}`" class="caption pa-2 lighten-2">{{m.content}}<br/><br/></div>
                                            </v-flex>
                                        </div>                                        
                                        <v-flex v-if="m.authorid === member.userid" class="chat-card-me-date caption" xs12 align-content-start justify-start>                                            
                                            <template >                                                
                                                <v-icon>person</v-icon><b>{{m.authorname}}</b>                                         
                                                {{m.datecreated}}
                                            </template>                                            
                                        </v-flex>
                                        <v-flex v-else class="chat-card-date caption" xs12 align-content-end justify-end>                                            
                                            <template >                                                
                                                <v-icon>person</v-icon><b>{{m.authorname}}</b>                                         
                                                {{m.datecreated}}
                                            </template>                                            
                                        </v-flex>                                        
                                    </v-flex>
                                    </v-layout>
                            </template>
                        </v-card-text>    
                        <v-card-text v-else>
                                <span v-if="memberProfileViewMessagesDoc" class="body-1">no messages in chat {{memberProfileViewMessagesDoc.chatname}} </span>
                                <span v-else class="body-1">no messages in chat  </span>
                        </v-card-text>
                            
                        </v-card>
            </template>

                        </v-card-text>

                   </v-card>
 



            </v-dialog>
    </v-flex>


    <v-flex xs12>

        <div class="font-weight-medium title pa-3">Reclaimation Stats </div>
        <carousel>
        <slide v-for="decade in Object.keys(memberRegStatsByDecade)" :key="'slide-' + decade">
            <v-card raised ripple :key="'vcard-' + decade">
                <v-card-text>
                    <div class="subheading primary--text lighten-2 font-weight-bold">{{decade}} Members</div>
                    <div><span class="title accent--text fofnt-weight-bold">{{memberRegStatsByDecade[decade].registeredmembers}}</span> <span class="grey--text">&nbsp;&nbsp;out of&nbsp;&nbsp;</span> <span class="primary--text">{{memberRegStatsByDecade[decade].totalmembers}}</span></div>
                    <div class="caption grey--text">have registered and logged-in</div>
                </v-card-text>
            </v-card>
        </slide>
        </carousel>    

        <div class="font-weight-medium title pa-3">Connect With Members </div>

          <template v-for="(item, index) in sortedLinesAndMembers">
            <div class="font-weight-medium subheading primary--text pa-1" v-bind:key="item.lineid">{{item.lineyear}} {{item.lineseason}}, {{item.linename}}</div>
            <v-list two-line dense v-bind:key="`vlist-${item.lineid}`" >
            <template v-for="(itemInner, indexInner) in item.linemembers">
            <v-list-tile :key="`vlisttile-${indexInner}`" avatar ripple @click="viewChat(itemInner)">
              <v-list-tile-avatar>
                <template v-if="itemInner.userid" >  
                <v-icon color="primary">person</v-icon> <v-icon color="red" small>star</v-icon>
                </template>
                <template v-else>
                <v-icon >person</v-icon>
                </template>
              </v-list-tile-avatar>                
              <v-list-tile-content>
                <v-list-tile-title v-if="itemInner.userid" class="primary--text font-weight-bold"> {{ itemInner.firstname }} {{ itemInner.lastname }}</v-list-tile-title>
                <v-list-tile-title v-else > {{ itemInner.firstname }} {{ itemInner.lastname }}</v-list-tile-title>
                <v-list-tile-sub-title>{{ item.linename }}</v-list-tile-sub-title>
              </v-list-tile-content>
            <v-list-tile-action>                                           
                <v-icon v-if="itemInner.userid" color="primary">chevron_right</v-icon>
                <v-icon v-else>chevron_right</v-icon>
            </v-list-tile-action>
            </v-list-tile>
            </template>
            </v-list>
            <v-divider :key="`divider-${index}`"></v-divider>
          </template>
        
    </v-flex>

  </v-layout>
  </v-container>
</template>

<script>
import firebase from 'firebase'
import * as d3 from 'd3'

  export default {
    data () {
        return {            
            dialogViewChat: false,
            snackbar: false,
            snackbarText: null,
            messagetext: null,
            memberProfileView: null,
            chatid: null,
            chatparticipants: [],
            chatparticipantnames: [],
            chatname: null,
            memberProfileViewMessagesDoc: null,
            memberProfileViewTemplate: {
                org: '',
                chapter: '',
                email: '',
                firstname: '',
                lastname: '',
                lineid: ''
            }
           
        }
    },
    created () {

        //TODO: variablize the entire page to be used for all post types based this.$route.path
        //console.log('.............route.name = ' , this.$route)
        //this.$store.dispatch('loadSortedLinesAndMembers', {chapter: 'zz'})
        this.memberProfileView = this.memberProfileViewTemplate
        //console.log('memberRegStatsByDecade',this.memberRegStatsByDecade)
    },
    computed: {
      myColor () {
         return this.$store.getters.myColor
      },         
      user () {
        return this.$store.getters.user
      },
      member () {
        return this.$store.getters.member
      },
      colorMain () {
          return this.$store.getters.colorMain
      },
      sortedLinesAndMembers () {
          return this.$store.getters.sortedLinesAndMembers
      },
      memberRegStatsByDecade(){
          const mbs = this.$store.getters.sortedLinesAndMembers
          var statsByDecade = new Object()
          mbs.forEach(element => {
              var decade = element.lineyear.toString().substring(0,3) + '0s'
              if(!statsByDecade[decade]){
                  statsByDecade[decade] = new Object()
                  statsByDecade[decade].totalmembers=0
                  statsByDecade[decade].registeredmembers=0
              }
              element.linemembers.forEach(lm=>{
                  statsByDecade[decade].totalmembers = statsByDecade[decade].totalmembers + 1
                  if(lm.userid){
                    statsByDecade[decade].registeredmembers = statsByDecade[decade].registeredmembers + 1
                  }
              })
          })
          return statsByDecade
      },
      memberMessagesDocs () {
          if(this.memberProfileView){
            return this.$store.getters.memberMessagesDocs
          }else{
              return []
          }          
      }          
    },
    watch: {
        memberProfileView(value){
            if(value){
                var uidsconcat
                var tmpparticipants = new Array()
                var tmpparticipantnames = new Array()
                var tmpchatname
                if(this.$store.getters.user.id < value.userid){
                    uidsconcat = this.$store.getters.member.userid + '_' + value.userid
                    //console.log('uidsconcat1', uidsconcat, value)
                    tmpparticipants.push(this.$store.getters.member.userid)
                    tmpparticipants.push(value.userid)
                    tmpparticipantnames.push(this.memberProfileView.firstname + ' ' + this.memberProfileView.lastname)
                    tmpparticipantnames.push(this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname)
                    tmpchatname = this.memberProfileView.firstname + ' ' + this.memberProfileView.lastname + ' and ' + this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
                }else{
                    uidsconcat = value.userid + '_' + this.$store.getters.member.userid
                    //console.log('uidsconcat2', uidsconcat, value)
                    tmpparticipants.push(value.userid)
                    tmpparticipants.push(this.$store.getters.member.userid )
                    tmpparticipantnames.push(this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname)
                    tmpparticipantnames.push(this.memberProfileView.firstname + ' ' + this.memberProfileView.lastname)                    
                    tmpchatname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname + ' and ' + this.memberProfileView.firstname + ' ' + this.memberProfileView.lastname                    
                }
                //this.chatid = this.$store.getters.org + '_' + this.$store.getters.chapter + '_chat_member_' + uidsconcat
                
                this.chatid = 'chat_member/' + this.$store.getters.chapter + '/' + uidsconcat

                this.chatparticipants = tmpparticipants
                this.chatparticipantnames = tmpparticipantnames
                this.chatname = tmpchatname
            }
        },
        memberMessagesDocs(value){
          if(value && value.length>0){
              //console.log('this.$store.getters.memberMessagesDocs', this.$store.getters.memberMessagesDocs)
              var tmpuserid = this.$store.getters.member.userid
              var tmpmemberprofileviewuserid = this.memberProfileView.userid
              //console.log('memberMessagesDocs BEFORE',value)
              var tmpMessageDocs =value.filter(function(mmd){
                    var rtn = false
                    if(mmd.participants.length===2){
                        //console.log('tmpMessageDocs PARTICIPANTS', mmd.participants)
                        var participants_removed_tmpuserid = mmd.participants.filter(function (e){return e!==tmpuserid})
                        //console.log('tmpMessageDocs PARTICIPANTS participants_removed_tmpuserid:' + tmpuserid, participants_removed_tmpuserid)
                        var participants_removed_tmpmemberprofileviewuserid = participants_removed_tmpuserid.filter(function (e){ return e!==tmpmemberprofileviewuserid})
                        //console.log('tmpMessageDocs PARTICIPANTS participants_removed_tmpmemberprofileviewuserid:' + tmpmemberprofileviewuserid, participants_removed_tmpmemberprofileviewuserid)
                        if(participants_removed_tmpmemberprofileviewuserid.length===0){
                            rtn= true
                        }
                    }
                    return rtn 
                    })
              if(tmpMessageDocs.length>0){
                  //console.log('memberMessagesDocs watcher... setting this.memberProfileViewMessagesDoc= ', tmpMessageDocs[0])
                this.memberProfileViewMessagesDoc = tmpMessageDocs[0]
              }else{
                  this.memberProfileViewMessagesDoc =null
              }
            
          }else{
              this.memberProfileViewMessagesDoc =null
          }             
        }
    },
    methods: {
        viewChat: function (objMember){
            this.memberProfileView = objMember
            this.openDialogViewChat()
        },
        openDialogViewChat: function (){
            this.dialogViewChat = true
        },
        closeDialogViewChat: function (){
            this.dialogViewChat = false
            this.memberProfileView = this.memberProfileViewTemplate
        },
        openSnackBar: function (){
            this.snackbar = true
        },
        closeSnackBar: function (){
            this.snackbar = false
            this.snackbarText = null
        },
        addMemberMessage: function (){
            var dt = new Date();
            var tmpdatemodified = dt.getTime()    
            var tmpchapter = this.$store.getters.member.chapter           
            var tmporg = this.$store.getters.member.org   
            var tmpmsg = this.messagetext
            var tmpchatid = this.chatid
            var objMessage = new Object()
            objMessage.datecreated = tmpdatemodified
            objMessage.authorid = this.$store.getters.user.id
            objMessage.authorname = this.$store.getters.member.firstname + ' ' + this.$store.getters.member.lastname
            objMessage.authorlineid = this.$store.getters.member.lineid
            objMessage.authoravatar = this.$store.getters.user.photoUrl
            objMessage.content = tmpmsg

            
            this.$store.dispatch('addMemberMessage', {chatid: tmpchatid, org: tmporg, chapter: tmpchapter, chatname: this.chatname, message: objMessage, participants: this.chatparticipants, participantnames: this.chatparticipantnames}).then(errmsg => {
            //console.log('msg', errmsg)
            if(errmsg && errmsg ==='failure'){
                console.error('addMemberMessage', errmsg) 
                this.snackbarText="Failed to send message."
                this.openSnackBar()
            }else{
                //console.log('successfully added message') 
                this.snackbarText="Message successfully sent."
                this.openSnackBar()
                this.messagetext=''
            }
            })  
            
            
        }         
    }
  }
</script>

<style>
#postFieldList .v-subheader{
    width:110px;
    padding-left: 0px;
    background-color: ghostwhite;
    margin-right: 8px;
}

#postComments .v-card{
    background-color:blue;
}
#fieldContainer .v-card__text{
    padding:5px;
}
.fieldlabel, .fieldlabel .v-card{
    background-color: ghostwhite;
    text-align: left;
}
.chat-card{
  border-radius:15px;
  padding-left:10px;
  margin-right:10px;  
  
}


.chat-card-me-date{
    text-align: right;
    margin-right:15px;
    color:dimgrey;
}

.chat-card-date{
    text-align: left;
    margin-right:15px;
    color:dimgrey;
}

.chat-card-me {
	position: relative;
	background: #DCDCDC;
	border-radius: .4em;
}

.chat-card-me:after {
	content: '';
	position: absolute;
	left: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
	border-right-color: #DCDCDC;
	border-left: 0;
	border-bottom: 0;
	margin-top: -10px;
	margin-left: -20px;
}

.chat-card {
	position: relative;
	background: #DCDCDC;
	border-radius: .4em;
}

.chat-card:after {
	content: '';
	position: absolute;
	right: 0;
	top: 50%;
	width: 0;
	height: 0;
	border: 20px solid transparent;
	border-left-color: #DCDCDC;
	border-right: 0;
	border-bottom: 0;
	margin-top: -10px;
	margin-right: -20px;
}

.profilekey {
    
}

.profilevalue {
    padding-left:5px;
}
</style>